import React, { useEffect } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { StringConvert } from '../components/StringConvert';



const truncateText = (text, maxLength) => {
    if(text) {
      if (text.length <= maxLength) {
        return text;
      }
      return text.slice(0, maxLength) + '...';
    }
    return text;
  };


const BlogsCard = ({data,alldata,deleted,permission}) => {
    const {id,blog_image,blog_paragraph,blog_slug,blog_title,blog_schedule} = data

    // Function to replace specific special characters
    function replaceSpecialCharacters(str) {
      if (!str) return ''; // Handle undefined or null input
      return str
        .replace(/&amp;/g, '&') // Replace encoded ampersand
        .replace(/&lt;/g, '<') // Replace encoded less-than
        .replace(/&gt;/g, '>') // Replace encoded greater-than
        .replace(/&quot;/g, '"') // Replace encoded double quotes
        .replace(/&#39;/g, "'"); // Replace encoded single quotes
    }

    // Replace special characters in blog_paragraph
    const cleanedParagraph = replaceSpecialCharacters(blog_paragraph);
    const formattedDate = dayjs(blog_schedule).format('MMMM D, YYYY');
    const handleDelete = () => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to delete?",
            buttons: true,
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    // swal("Successfully Delete", "", "success");
                    // apiMethodDelete(`blogs/delete/${id}`)
                }

            });
    }
    const [resDelete, apiMethodDelete] = useDelete()
    useEffect(() => {
        if(resDelete.data) {
          const {message} = resDelete.data
          const update = alldata.filter((item) => item.id !== id)
          deleted(update)
          toast.success(message);
        }
      }, [resDelete.data])

      const maxLength = 200;
      const truncatedText = truncateText(cleanedParagraph, maxLength);
 const check = (module, action) => permission?.[module]?.includes(action);
    return (
        <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
            <Link
                className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center"
                to={`/blogs/edit/${id}`}
            >
                <div className="BlogsCard__left w-full lg:w-[12rem] lg:flex-none">
                    <img
                        src={blog_image}
                        className='h-[9rem] w-full rounded-[1.25rem] object-cover lg:h-[6rem]'
                        alt={blog_title || "blog image"}
                    />
                </div>
                <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
                    <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-[#667085]">
                        <span className="rounded-full bg-[#EFF4FD] px-3 py-1 font-MluvkaBold text-[#3B4A69]">
                            {formattedDate}
                        </span>
                        {blog_slug && (
                            <span className="truncate rounded-full bg-[#F7F7FB] px-3 py-1">
                                /{blog_slug}
                            </span>
                        )}
                    </div>
                    <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] font-MluvkaLight capitalize leading-[1.2] text-[#101828] lg:text-[1.25rem]">
                        {blog_title}
                    </div>
                    <div className='max-h-[4.9rem] overflow-hidden text-[.88rem] leading-[1.65] text-[#475467]'>
                        {StringConvert(truncatedText)}
                    </div>
                </div>
                {/* <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
                    <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
                    <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
                        Edit
                    </span>
                </div> */}
            </Link>
        </div>
    )
}

export default BlogsCard
